/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { InfoNotification } from '../../../app.notification';
import { AxiosErrorResponse } from '../../../app.settings';

import api from '../../../axios';
import { IMicroRegiao } from './model';

export async function getById(usuarioId: string): Promise<IMicroRegiao | any> {
  try {
    const { data } = await api.get<AxiosResponse<IMicroRegiao>>('/micro_regiao/' + usuarioId);
    return data as unknown as IMicroRegiao;
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
export async function getAll(): Promise<IMicroRegiao[] | undefined> {
  try {
    const { data } = await api.get<AxiosResponse<IMicroRegiao[]>>('/micro_regiao');
    return data as unknown as IMicroRegiao[];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function update(usuario: Partial<IMicroRegiao>): Promise<IMicroRegiao | any> {
  try {
    const { data } = await api.put<AxiosResponse<IMicroRegiao>>('/micro_regiao/' + usuario.id, {
      ...usuario,
    });
    return (data as unknown as IMicroRegiao[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function insert(usuario: IMicroRegiao): Promise<IMicroRegiao | any> {
  try {
    const { data } = await api.post<AxiosResponse<IMicroRegiao>>('/micro_regiao/', {
      ...usuario,
    });
    return (data as unknown as IMicroRegiao[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function save(usuario: IMicroRegiao): Promise<IMicroRegiao | any> {
  try {
    if (usuario.id) {
      return await update(usuario).then(() => {
        InfoNotification('Registro alterado!');
      });
    } else {
      return await insert(usuario).then(() => {
        InfoNotification('Registro criado!');
      });
    }
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function remove(usuarioId: string): Promise<IMicroRegiao | any> {
  try {
    return await api.delete<AxiosResponse<IMicroRegiao>>('/micro_regiao/' + usuarioId).then(() => {
      InfoNotification('Registro excluido!');
    });
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
